import { useEffect, useState } from 'react';
import { BrowserRouter, Switch, Redirect } from 'react-router-dom';

import { user } from 'services';
import { Layout } from 'libs/ui';
import { Auth } from 'pages/auth';
import { RoutePublic } from './route-type/route-public';
import { RoutePrivate } from './route-type/route-private';
import { getActiveSections } from './access-helper';
import { components } from './components';

const empty = { path: '/empty' };

export const Router = ({ logined }) => {
  const permissions = user.getPermissions();

  const getSections = () => {
    const out = getActiveSections(permissions);
    // find default page
    let def = out.find((el) => el.id === 'stays');
    if (!def) {
      def = out.length ? out.find((el) => el.type === 'section') : { path: empty };
    }
    if (!def) {
      def = empty;
    }
    return {
      sections: out,
      defaultPath: def.path,
    };
  };
  const { defaultPath, sections } = getSections();

  /**
   * get routes from sections
   * @returns
   */
  const getRoutes = () => {
    if (!logined) {
      return null;
    }
    return sections.map((section, idx) => {
      const cmp = section.type === 'section' ? components['section'] : components[section.id];
      return (
        <RoutePrivate
          key={idx}
          path={section.path}
          component={cmp}
          defaultPath={defaultPath}
          params={{
            sectionName: section.name,
            subsectionList: section.subsections,
            subRoutes: section.subRoutes,
          }}
        />
      );
    });
  };
  
  // console.log('router logined', logined);
  return (
    <BrowserRouter>
      <Switch>
        <RoutePublic exact path="/" component={Auth} defaultPath={defaultPath} />
        <RoutePublic path="/auth" component={Auth} defaultPath={defaultPath} />

        <Layout sections={sections}>
          <Switch>
            {getRoutes()}
            <Redirect to="/auth" />
          </Switch>
        </Layout>

        <Redirect to="/auth" />
      </Switch>
    </BrowserRouter>
  );
};
